import { dayColorVar } from '../lib/cn'

export function DayBadge({ dayIndex }: { dayIndex: number }) {
  return (
    <span
      className="inline-flex h-7 min-w-7 items-center justify-center rounded-st-full px-2 text-xs font-semibold text-white"
      style={{ backgroundColor: dayColorVar(dayIndex) }}
    >
      Day {dayIndex + 1}
    </span>
  )
}
